/**
 * Full-screen referral onboarding shown once, when a student finishes their
 * third practice exam. Reached from the exam report's "Return Home".
 */
export const REFERRAL_ONBOARDING_PATH = "/refer/get-started";

/**
 * Where the onboarding releases the student. Mirrors the exam report's own
 * "Return Home" destination so the redirect reads as one extra step, not a
 * detour.
 */
export const REFERRAL_ONBOARDING_EXIT_PATH = "/practice-hub";

/**
 * Practice exams (any category, including the one just finished) that trigger
 * the onboarding. Checked with `>=` so students already past this point when
 * the feature ships still see it once.
 */
export const REFERRAL_ONBOARDING_EXAM_THRESHOLD = 3;

/**
 * How the student reached the onboarding, carried on the Viewed event.
 * `practice_exam` = diverted by `PostExamSequence`; `direct` = typed the URL
 * or followed a link. Anything else in router state is clamped to `direct`.
 */
export const REFERRAL_ONBOARDING_TRIGGERS = [
  "practice_exam",
  "direct",
] as const;
export type ReferralOnboardingTrigger =
  typeof REFERRAL_ONBOARDING_TRIGGERS[number];

/** Router state `PostExamSequence` passes when it diverts into the screen. */
export type ReferralOnboardingLocationState = {
  trigger?: ReferralOnboardingTrigger;
  /** Practice exams completed including the one just finished. */
  examCount?: number;
};

/** Instagram has no web share intent; we copy the link and open the app. */
export const INSTAGRAM_URL = "https://www.instagram.com/";
